import { supplierGridProperties } from '../../data/suppliers-properties';

type ColumnConfig = {
  id: string;
  minWidth: number;
  width: number;
  pinned: boolean;
  nonsortable: boolean;
  index: number;
};

/**
 * Default configuration for base supplier grid columns
 * Defines width, sorting, pinning, and ordering for each column
 */
export const baseColumnsDefaultConfigs: ColumnConfig[] = [
  {
    id: supplierGridProperties.supplierName,
    minWidth: 100,
    width: 150,
    pinned: false,
    nonsortable: false,
    index: 0,
  },
  {
    id: supplierGridProperties.supplierEmail,
    minWidth: 100,
    width: 200,
    pinned: false,
    nonsortable: false,
    index: 1,
  },
  {
    id: supplierGridProperties.supplierAddress,
    minWidth: 100,
    width: 300,
    pinned: false,
    nonsortable: true,
    index: 2,
  },
  {
    id: supplierGridProperties.supplierCountry,
    minWidth: 100,
    width: 150,
    pinned: false,
    nonsortable: false,
    index: 3,
  },
  {
    id: supplierGridProperties.contactName,
    minWidth: 100,
    width: 150,
    pinned: false,
    nonsortable: false,
    index: 4,
  },
  {
    id: supplierGridProperties.contactPhone,
    minWidth: 100,
    width: 150,
    pinned: false,
    nonsortable: true,
    index: 5,
  },
];
